import type { TextFilterModel } from '@seeqdev/ag/grid';

/** The ids in an identity column's comma-separated filter; none when a hand-edited URL restored a non-string. */
export const splitIdentityIds = (filter: unknown): string[] =>
  typeof filter === 'string'
    ? filter
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean)
    : [];

/**
 * The text filter model an identity column holds for these ids, or null to clear it.
 * getIdentityFilterValue() splits the comma-separated IDs for creatorIds/ownerIds API params.
 */
export const buildIdentityTextFilterModel = (identityIds: string[]): TextFilterModel | null =>
  identityIds.length > 0 ? { filterType: 'text', type: 'contains', filter: identityIds.join(',') } : null;

export const getIdentityFilterValue = (colId: string) => (filter: unknown, columnKey: string) =>
  columnKey === colId ? splitIdentityIds(filter) : filter;
